'use strict';

var _slicedToArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/slicedToArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var debug = require('debug');

var equals = require('uint8arrays/equals');

var entry = require('../message/entry.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var debug__default = /*#__PURE__*/_interopDefaultLegacy(debug);

var logger = function logger(id, subsystem) {
  var name = ['bitswap'];

  if (subsystem) {
    name.push(subsystem);
  }

  if (id) {
    name.push("".concat(id.toB58String().slice(0, 8)));
  }

  return Object.assign(debug__default["default"](name.join(':')), {
    error: debug__default["default"](name.concat(['error']).join(':'))
  });
};

var includesWith = function includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;

  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }

    idx += 1;
  }

  return false;
};

var uniqWith = function uniqWith(pred, list) {
  var idx = 0;
  var len = list.length;
  var result = [];
  var item;

  while (idx < len) {
    item = list[idx];

    if (!includesWith(pred, item, result)) {
      result[result.length] = item;
    }

    idx += 1;
  }

  return result;
};

var groupBy = function groupBy(pred, list) {
  return list.reduce(function (acc, v) {
    var k = pred(v);

    if (acc[k]) {
      acc[k].push(v);
    } else {
      acc[k] = [v];
    }

    return acc;
  }, {});
};

var pullAllWith = function pullAllWith(pred, list, values) {
  return list.filter(function (i) {
    return !includesWith(pred, i, values);
  });
};

var sortBy = function sortBy(fn, list) {
  return Array.prototype.slice.call(list, 0).sort(function (a, b) {
    var aa = fn(a);
    var bb = fn(b);
    return aa < bb ? -1 : aa > bb ? 1 : 0;
  });
};

var isMapEqual = function isMapEqual(a, b) {
  if (a.size !== b.size) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
          key = _step$value[0],
          valueA = _step$value[1];

      var valueB = b.get(key);

      if (valueB === undefined) {
        return false;
      }

      if (valueA instanceof Uint8Array && valueB instanceof Uint8Array && !equals.equals(valueA, valueB)) {
        return false;
      }

      if (valueA instanceof entry.BitswapMessageEntry && valueB instanceof entry.BitswapMessageEntry && !valueA.equals(valueB)) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
};

exports.groupBy = groupBy;
exports.includesWith = includesWith;
exports.isMapEqual = isMapEqual;
exports.logger = logger;
exports.pullAllWith = pullAllWith;
exports.sortBy = sortBy;
exports.uniqWith = uniqWith;